export default "__VITE_ASSET__KdsP364y__"